import React, { useRef } from "react";
import { ArrowDownOutlined } from "@ant-design/icons";
import { Wrapper } from "./LeadListCard.styled";
import { Button } from "components/common"
import { Row, Col } from "components/common";
import LeadListCardEntity from "./LeadListCardEntity/LeadListCardEntity";

const LeadListCard = ({ data, status, users, setIsSortLoading, pagination, updatePagination }) => {

    const loadMoreRecords = () => {

        if (data.length < parseInt(pagination.total)) {
            setIsSortLoading(false);
            updatePagination(0, parseInt(pagination.limit) + 10)
        };
    }

    return (
        <Wrapper>
            <Row gutter={[15, 15]}>
                {data.map((item) => {
                    return (
                        <Col key={item?._id} xs={24} md={24}>
                            <LeadListCardEntity data={item} status={status} users={users} />
                        </Col>
                    );
                })}
            </Row>
            {data.length < parseInt(pagination.total) && (
                <div className="scroll-button-container">
                    <button className="scroll-button" onClick={loadMoreRecords}>
                        <ArrowDownOutlined style={{ color: 'white', fontSize: 20 }} />
                    </button>
                </div>
            )}
        </Wrapper>
    );
};

export default LeadListCard;
